import { useAuth } from '@frontegg/nextjs';
import { createIntercomUserId } from '@zorro/common-utils';
import { parseDate } from '@zorro/shared/formatters';
import { useMonolithQuery, useRoles } from '@zorro/web/ui-utils';
import { useEffect } from 'react';

import { bootIntercom } from './intercom-service';

export const IntercomWidget = () => {
  const { user, isAuthenticated } = useAuth();
  const { isAgent } = useRoles();

  const intercomUserId =
    user?.email && user.tenantId
      ? isAgent
        ? user.email
        : createIntercomUserId(user.email, user.tenantId)
      : undefined;

  const { data: hashData, isLoading: isLoadingHash } = useMonolithQuery({
    method: 'intercomControllerGenerateHash',
    params: intercomUserId && [{ intercomUserId }],
  });

  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_INTERCOM_ID;

    if (
      !isAuthenticated ||
      !user ||
      !intercomUserId ||
      isLoadingHash ||
      !hashData?.hash ||
      !appId
    ) {
      return;
    }

    void bootIntercom({
      app_id: appId,
      email: user.email,
      name: user.name,
      created_at: user.createdAt ? parseDate(user.createdAt).unix() : undefined,
      user_id: intercomUserId,
      user_hash: hashData.hash,
      hide_default_launcher: true,
      alignment: 'right',
    });
  }, [isAuthenticated, user, intercomUserId, isLoadingHash, hashData]);

  return null;
};
